import React, { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import logo from '../assets/images/logo.png';

interface WizardLayoutProps {
    children?: ReactNode;
}

const WizardLayout: React.FC<WizardLayoutProps> = ({ children }) => {
    return (
        <div className="min-h-screen relative overflow-hidden bg-gradient-to-b from-slate-50 via-white to-sky-50">
            {/* Soft background glow blobs */}
            <div className="pointer-events-none absolute -top-24 -left-24 h-72 w-72 rounded-full bg-sky-200/30 blur-3xl" />
            <div className="pointer-events-none absolute top-20 -right-24 h-80 w-80 rounded-full bg-violet-200/25 blur-3xl" />
            <div className="pointer-events-none absolute bottom-0 left-1/3 h-72 w-72 rounded-full bg-emerald-200/20 blur-3xl" />

            {/* Header with Logo */}
            <div className="absolute top-0 left-0 right-0 p-6 flex justify-center z-10">
                <img src={logo} alt="VisaConnect" className="h-10 w-auto" />
            </div>

            {/* Content Container */}
            <div className="relative z-10 min-h-screen flex flex-col justify-center py-20 px-4 sm:px-6 lg:px-8">
                <div className="w-full max-w-md mx-auto">
                    {children || <Outlet />}
                </div>
            </div>
        </div>
    );
};

export default WizardLayout;
